import { HTMLAttributeAnchorTarget, useEffect, useState } from 'react';
import { checkSameHostUrl } from './SchedulingButton.helpers';
import { scheduleButtonStyles } from './SchedulingButton.styles';
import TAGButton from '@shared-components/components/TAGButton';
import { useAppContext } from '@shared-components/context';
import { Maybe } from '@shared-components/types';
import { clickContext } from '@utils';
import { normalizeDomainLink } from '@utils/normalizeDomainLink';
interface IProps {
  schedulingButtonUrlMobile?: Maybe<string>;
  schedulingButtonTextMobile?: Maybe<string>;
  schedulingButtonUrl?: Maybe<string>;
  schedulingButtonText?: Maybe<string>;
  isMobile?: boolean;
}
export default function SchedulingButton({
  schedulingButtonUrlMobile,
  schedulingButtonUrl,
  schedulingButtonTextMobile,
  schedulingButtonText,
  isMobile
}: Readonly<IProps>) {
  const {
    config
  } = useAppContext();
  const url = schedulingButtonUrl ? normalizeDomainLink(schedulingButtonUrl) ?? '/schedule-an-appointment' : '/schedule-an-appointment';
  const label = schedulingButtonText || 'Schedule appointment';
  const resolvedMobileUrl = isMobile && schedulingButtonUrlMobile ? normalizeDomainLink(schedulingButtonUrlMobile) ?? url : url;
  const resolvedMobileLabel = isMobile && schedulingButtonTextMobile ? schedulingButtonTextMobile : label;
  const [buttonTarget, setButtonTarget] = useState<HTMLAttributeAnchorTarget>('_self');
  useEffect(() => {
    const host = globalThis.location?.host ?? '';
    const isSameHost = checkSameHostUrl(host, isMobile && resolvedMobileUrl ? resolvedMobileUrl : url);
    if (!isSameHost) {
      setButtonTarget('_blank');
    }
  }, [resolvedMobileUrl, url, isMobile]);
  return <TAGButton href={resolvedMobileUrl} size={isMobile ? 'XS' : 'S'} variant="primaryAccent1" sx={scheduleButtonStyles} dataTestId="button_schedule_desktop" analyticsContext={clickContext({
    brand: config.name,
    type: 'scheduleClick'
  })} target={buttonTarget} data-sentry-element="TAGButton" data-sentry-component="SchedulingButton" data-sentry-source-file="SchedulingButton.tsx">
			{resolvedMobileLabel}
		</TAGButton>;
}